// Stand-in for the metrics API behind the Charts tab, which the backend does not have yet.
// The campaign list and decision history use the real APIs (miloApi.js).
import metricsSample from "./sampleData/campaign-900001-metrics.json"

const FAKE_LATENCY_MS = 400

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// GET /api/v1/admin/pricing_advisor/campaigns/:id/metrics (not built yet)
export const fetchMiloCampaignMetrics = async (campaignId) => {
    await wait(FAKE_LATENCY_MS)
    if (campaignId === metricsSample.data.campaign_id) return metricsSample
    return { data: { campaign_id: campaignId, charts: null }, additional_data: {} }
}
